import { render, staticRenderFns } from "./RowHeader.vue?vue&type=template&id=63f732c6&scoped=true"
import script from "./RowHeader.vue?vue&type=script&lang=js"
export * from "./RowHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f732c6",
  null
  
)

export default component.exports